module.exports = __webpack_public_path__ + "img/dslr@2x.75624248.png";